export interface MobileSignInSession {
  id: number;
  app_type: MobileSignInSessionType;
  app_label: string;
  created: string;
  is_deleted: boolean;
}

export enum MobileSignInSessionType {
  Android = 1,
  iOS = 2
}

export interface MobileSignInStartData {
  code: string;
  id: number;
  result: MobileSignInCheckResult;
}

export interface MobileSignInCheckData {
  id: number;
  result: MobileSignInCheckResult;
}

export enum MobileSignInCheckResult {
  InProgress = 0,
  Finished = 1,
  Failed = 2,
  Expired = 3
}
